import { useCallback, useContext, useEffect, useState } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";
import moment from "moment";

import Pagination from "../../common/Pagination";
import RecordsPerPage from "../../common/RecordsPerPage";
import { AppContexts } from "../../../providers";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";

const ChatbotLogs = () => {
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const { active, chatbotLogs, startDate, endDate, getChatbotLogs } = useContext(
    AppContexts.ReportsContext
  );

  const path = usePath();
  const { total, paginated } = chatbotLogs;

  useEffect(() => {
    if (path !== active) setPage(0);
  }, [path]);

  useEffect(() => {
    if (active === "chatbot-logs") getFn(startDate, endDate);
  }, [page, recordsPerPage]);

  const getFn = useCallback(
    (start, end) => {
      if (!start || !end) {
        return;
      } else {
        getChatbotLogs(start, end, page, recordsPerPage);
      }
    },
    [page, recordsPerPage]
  );

  const handlePageChange = useCallback((page) => setPage(page), []);

  return (
    <li className="reports-tab-content">
      <h2>AI Chatbot Logs</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel onSubmit={getFn} />
        <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
          <thead>
            <tr>
              <th>ACTIVITY DATE</th>
              <th>QUESTION</th>
              <th>AI RESPONSE</th>
            </tr>
          </thead>
          <tbody>
            {paginated?.length ? (
              paginated?.map((item) => (
                <tr key={item.id}>
                  <td>{moment.utc(item.created_at).local().format("MM/DD/YYYY hh:mm A")}</td>
                  <td>{item.question}</td>
                  <td>{item.answer}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="no-results">
                  No results for this date range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination
          count={total}
          index={page}
          onIndexChanged={handlePageChange}
        />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default ChatbotLogs; 